/**
 * @ngdoc services
 * @memberof mercury.modules.stock
 * @name StocktakeTemplates
 * @description Data access service to manage stocktake templates
 */
angular.module('mercury.modules.stock.stocktaketemplate')
.factory('StocktakeTemplates', ["$resource", "settings", function($resource, settings) {
  var StocktakeTemplates = $resource(settings.apiHost + '/r/StocktakeTemplates/:id', {id: '@id'}, {patch: {method: 'PATCH'}});
  var StocktakeTemplateLine = $resource(settings.apiHost + '/r/StocktakeTemplateLines/:id', {id: '@id'}, {update: {method: 'PUT'}, patch: {method: 'PATCH'}});

  /**
   * Get a summary for all active stocktake templates
   *
   * @memberof StocktakeTemplates
   */
  function getAllActive() {
    return StocktakeTemplates.query({$filter: 'DatestampDeleted eq null'});
  }

  /**
   * Get a summary of all stocktake template that are areas and have common items with the given stocktake
   *
   * @memberof StocktakeTemplates
   * @param  {String} stocktakeId Id of the stocktake to check for common items against the templates
   */
  function getAllAreaTemplates(stocktakeId) {
    return StocktakeTemplates.query({stocktakeId: stocktakeId});
  }

  /**
   * Get the full model of the specific template
   *
   * @memberof StocktakeTemplates
   * @param  {String} id Id of the stocktake template to get
   */
  function get(id) {
    return StocktakeTemplates.get({id: id});
  }

  /**
   * Create a new stocktake template using the given parameters
   *
   * @memberof StocktakeTemplates
   * @param  {Object} params Object of params to pass to create endpoint
   */
  function create(params) {
    return StocktakeTemplates.save(params, {}).$promise;
  }

  /**
   * Update an existing stocktake template
   *
   * @memberof StocktakeTemplates
   * @param  {Object} template Updated stocktake template model
   */
  function update(template) {
    return StocktakeTemplates.update(template).$promise;
  }

  /**
   * Set the specified stocktake template as deleted
   *
   * @memberof StocktakeTemplates
   * @param  {Object} template Template model to set as deleted
   */
  function remove(template) {
    return StocktakeTemplates.patch({id: template.id, datestampDeleted: moment().format()}).$promise;
  }

  /**
   * Add a new stocktake template line
   *
   * @memberof StocktakeTemplates
   * @param  {Object} line New stocktake template line
   */
  function createLine(line) {
    var promise = StocktakeTemplateLine.save(line).$promise;

    promise.then(function(savedLine) {
      line.id = savedLine.id;
    });

    return promise;
  }

  /**
   * Update multiple stocktake template lines
   *
   * @memberof StocktakeTemplates
   * @param  {String} templateId Id of the template all the lines belong to
   * @param  {Object} lines      Array of template lines to update
   */
  function updateManyLines(templateId, lines) {
    return StocktakeTemplateLine.update({templateId: templateId}, lines).$promise;
  }

  /**
   * Set the default count of the specified stocktake template line
   *
   * @memberof StocktakeTemplates
   * @param  {String} id              Id of the stocktake template line to update
   * @param  {Number} newDefaultCount New default count
   */
  function updateLineDefaultCount(id, newDefaultCount) {
    return StocktakeTemplateLine.patch({id: id}, {defaultCount: newDefaultCount}).$promise;
  }

  /**
   * Set the unit of a specified stocktake template line
   *
   * @memberof StocktakeTemplates
   * @param  {String} id        Id of the stocktake template line to update
   * @param  {String} newUnitId New line unit id
   */
  function updateLineUnit(id, newUnitId) {
    return StocktakeTemplateLine.patch({id: id}, {unitId: newUnitId}).$promise;
  }

  /**
   * Delete a spcified stocktake template line
   *
   * @memberof StocktakeTemplates
   * @param  {Object} line Model of the stocktake template line to delete
   */
  function deleteLine(line) {
    return StocktakeTemplateLine.delete({id: line.id}).$promise;
  }

  return {
    getAllActive: getAllActive,
    getAllAreaTemplates: getAllAreaTemplates,
    get: get,
    create: create,
    update: update,
    remove: remove,
    createLine: createLine,
    deleteLine: deleteLine,
    updateLineDefaultCount: updateLineDefaultCount,
    updateLineUnit: updateLineUnit,
    updateManyLines: updateManyLines
  };
}]);
